import { useEffect, useState } from 'react';
import { fetchCohortImage } from '../../../services/schools';
import HeroGraphic from '../../../assets/images/hero-shot.png';
import UConn from '../../../assets/images/uconn.png';
import Aditya from '../../../assets/images/as.png';
import Patrick from '../../../assets/images/pl.png';
import Testimonal from './Testimonial';

interface SignupDisplayProps {
  cohort: string;
  isGroupSignup: boolean;
  isLogin: boolean;
}

interface ConfigObject {
  superhead?: string;
  title: string;
  image?: string;
  benefits: string[];
  curator?: string;
  curatorImage?: string;
}

const DEFAULT_TITLE = 'Med school can be simpler';

// const DEFAULT_BENEFITS = [
//   'Over 12,000 QBank questions',
//   'Over 25,000 flashcards',
//   'Over 1,700 library articles',
// ];

const SIGNUP_DISPLAY_CONFIG: Record<string, ConfigObject> = {
  stanford: {
    superhead: 'Stanford School of Medicine',
    title: 'Science of Medicine 1',
    benefits: [],
  },
  ucsf: {
    superhead: 'UCSF School of Medicine',
    title: 'Pathogens & Host Defenses',
    benefits: [],
  },
  group: {
    title: 'Join an Ora group',
    benefits: [],
  },
  default: {
    title: DEFAULT_TITLE,
    benefits: [],
  },
};

const SignupDisplay = ({
  cohort,
  isGroupSignup,
  isLogin,
}: SignupDisplayProps) => {
  const [cohortImage, setCohortImage] = useState<string | null>(null);

  const dispalyConfig = isGroupSignup
    ? SIGNUP_DISPLAY_CONFIG.group
    : cohort && SIGNUP_DISPLAY_CONFIG[cohort]
      ? SIGNUP_DISPLAY_CONFIG[cohort]
      : SIGNUP_DISPLAY_CONFIG.default;

  useEffect(() => {
    if (cohort) {
      getCohortImage(cohort);
    }
  }, [cohort]);

  const getCohortImage = async (cohort: string) => {
    const response = await fetchCohortImage(cohort);
    if (response) {
      setCohortImage(response);
    }
  };

  return (
    <>
      <div className="signup-display">
        <div className="signup-display_content">
          <div
            className={`signup-display_content_header ${
              cohort && cohortImage ? 'is-cohort' : ''
            }`}
          >
            <h1>
              {dispalyConfig.superhead && (
                <span className="superhead">{dispalyConfig.superhead}</span>
              )}
              <span className="title">{dispalyConfig.title}</span>
            </h1>
          </div>
          {!dispalyConfig.curator && !(cohort && cohortImage) && (
            <div className="signup-display_content_main">
              <div className="graphic">
                <div className="hero-wrapper">
                  <img src={HeroGraphic} alt="Ora AI QBank Product Shot" />
                  <div className="testimonial--3">
                    <Testimonal
                      headshot={UConn}
                      quote={
                        "I love Ora, I tell all my classmates to use it. It's difficult to know what you don't know, but with Ora, you don't have to think about what to study - AI does it for you, so you can just sit down and start doing questions."
                      }
                      name={'Ariel Kogan Zajdman, 2nd-Year MD/PhD Student'}
                      school={'University of Connecticut School of Medicine'}
                    />
                  </div>
                  <div className="testimonial--1">
                    <Testimonal
                      headshot={Aditya}
                      quote={
                        'This is a smarter UWorld. It has UWorld-equivalent questions, and it quickly identifies your weaknesses and builds a regimented plan to help you attack them. It&apos;s basically a blend between UWorld and Anki.'
                      }
                      name={'Aditya Shah, MS2'}
                      school={'Central Michigan University College of Medicine'}
                    />
                  </div>
                  <div className="testimonial--2">
                    <Testimonal
                      headshot={Patrick}
                      quote={
                        'Ora considers the learning science behind every detail...'
                      }
                      name={'Patrick Lawson, PhD'}
                      school={'Doctorate in Applied Cognition'}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {cohort && cohortImage && !isLogin && (
        <div className="cohort-background-wrapper">
          <div className="cohort-background-wrapper_overlay"></div>
          <img
            className="cohort-background"
            src={cohortImage}
            alt={dispalyConfig.title}
          />
        </div>
      )}
    </>
  );
};

export default SignupDisplay;
